import { inject, Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { catchError, firstValueFrom, map, Observable, Subscriber, tap, TeardownLogic, throwError } from 'rxjs';
import { MasterdataRequestDTO } from '../models/MasterdataRequestDTO.model';
import { FileDTO } from '../models/FileDTO.model';
import { DeviceDTO } from '../models/DeviceDTO.model';
import { PlanDeviceDTO } from '../models/PlanDeviceDTO.model';
import { ApiRoutesEnum } from '../shared/enums/ApiRoutes.enum';
import { MassImportSimsResponse } from '../models/MassImportSimsResponse';
import { ResponseDataFile } from '../shared/models/ApiResponse';
import { PlanAvailableDTO } from '../models/PlanAvailableDTO.model';
import { ResponseBase } from '../models/ResponseBase';
import { UnassignedCustomerDeviceDto } from '../models/UnassignedCustomerDeviceDto';
import { DataFile } from '../models/DataFile.model';
import { GetListPlansAvailablesRequest } from '../models/GetListPlansAvailablesRequest.model';
import { AlertService } from '../shared/services/alert.service';
import { HttpClient } from '@angular/common/http';
import { ApiResponse, PageableRequest as PagableRequest, PageableResponse as PagableResponse, PageArray } from '../models/ApiResponse';

/** Параметры запроса на получение текущего журнала аудита */
export interface LoadNotesRequestDTO extends PagableRequest {
    /** Идентификатор клиента */
    customerId: number;
}
export enum NoteVisibility {
    Internal = 1,
    External = 2
}

export function noteVisiblilityText(v: NoteVisibility): string {
    switch (v) {
        case NoteVisibility.Internal: return 'INTERNAL'
        case NoteVisibility.External: return 'External'
        default: return `Unknown ${v}`;
    }
}

export enum NoteType {
    General = 0,
    Call = 1,
    Billing = 2,
    TechSupport = 3
}

export function noteTypeText(v: NoteType): string {
    switch (v) {
        case NoteType.General: return 'General'
        case NoteType.Call: return 'Call'
        case NoteType.Billing: return 'Billing'
        case NoteType.TechSupport: return 'TechSupport'
        default: return `Unknown ${v}`;
    }
}

export interface NoteDTO {
    id?: number;
    dateCreated?: string;
    userId?: string;
    userName?: string;
    visibility: NoteVisibility;
    noteType?: NoteType;
    noteText: string;
    customerId: number;
    answerToNoteId?: number;
}

@Injectable({ providedIn: 'root' })
export class NotesService {

    private http = inject(HttpService);

    loadAsync(request: LoadNotesRequestDTO) {
        return this.http.postAsync<PageArray<NoteDTO>>(ApiRoutesEnum.LoadNotes, request);
    } 

    createAsync(note: NoteDTO) {
        return this.http.postAsync<number>(ApiRoutesEnum.CreateNotes, note);
    }
}
